import React, { Component } from "react";
import http from "../../../services/HttpService";
class UserProfileShorcout extends Component {
  state = {
    user_infos: [],
    user_saveApp:[]
  };
  componentDidMount() {
    this.getUserInfo();
    this.props.check(JSON.parse(localStorage.getItem('logged_user')))
  }
componentWillReceiveProps(){
    this.getUserInfo();
}
  getUserInfo() {
    const user_id = JSON.parse(localStorage.getItem("logged_user"));
    user_id &&
      http
        .get(`/users/getUsersVotesTool/${user_id.id}`)
        .then((response) => response.json())
        .then((data) => {
          const a = [];

          this.setState(
            {
              user_infos: data,
            },
            this.getUserSaveAppInfo
          );
        });
  }
  getUserSaveAppInfo() {

    const user_id = JSON.parse(localStorage.getItem('logged_user'));
    user_id &&
        http.get(`/users/getUsersTool/${user_id.id}`)
            .then(response => response.json())
            .then((data) => {
                const a = [];


                this.setState({
                    user_saveApp: data
                });
            });
}
  render() {
    const user = JSON.parse(localStorage.getItem("logged_user"));

    return (
      <div>
        <div className="profileInfo">
          <div className="profileInfo_img">
            <img src={user.img ? user.img : "/anonymous.png"} />
          </div>

          <h5>{user.name + " " + user.surname}</h5>
          <div>
            <div className="skillAndVotesCount">
              <img src="/skillCount.png" />
              <h6>{this.state.user_infos.length} skilled app</h6>
            </div>
            <div className="skillAndVotesCount">
              <img src="/voteCount.png" />
              <h6>{this.state.user_saveApp.length} votes</h6>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UserProfileShorcout;
